import NewProductApply from './new_product_apply.vue';

export default NewProductApply;
